import React from 'react';
import { Plus, MapPin, Edit2, Trash2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { Header } from '../components/ui/Header';
import { Button } from '../components/ui/Button';
export function AddressBookScreen() {
  const addresses = [{
    id: 1,
    name: 'John Doe',
    type: 'Home',
    address: '123 Main Street, Apt 4B',
    city: 'New York, NY 10001',
    phone: '+1 (234) 567-8900',
    isDefault: true
  }, {
    id: 2,
    name: 'John Doe',
    type: 'Work',
    address: '456 Business Blvd, Suite 200',
    city: 'San Francisco, CA 94105',
    phone: '+1 (234) 567-8901',
    isDefault: false
  }];
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="min-h-screen bg-gray-50 pb-24" data-id="element-216">
      <Header title="Address Book" data-id="element-217" />

      <div className="p-4 space-y-4" data-id="element-218">
        {addresses.map(addr => <div key={addr.id} className="bg-white p-4 rounded-2xl shadow-sm border border-gray-50 relative" data-id="element-219">
            {addr.isDefault && <span className="absolute top-4 right-4 bg-primary/10 text-primary text-[10px] font-bold px-2 py-1 rounded" data-id="element-220">
                DEFAULT
              </span>}
            <div className="flex items-start gap-3 mb-3" data-id="element-221">
              <div className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center shrink-0" data-id="element-222">
                <MapPin className="w-5 h-5 text-gray-500" data-id="element-223" />
              </div>
              <div data-id="element-224">
                <h3 className="font-bold text-gray-900 flex items-center gap-2" data-id="element-225">
                  {addr.name}
                  <span className="text-xs font-normal text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full" data-id="element-226">
                    {addr.type}
                  </span>
                </h3>
                <p className="text-sm text-gray-600 mt-1" data-id="element-227">{addr.address}</p>
                <p className="text-sm text-gray-600" data-id="element-228">{addr.city}</p>
                <p className="text-sm text-gray-500 mt-1" data-id="element-229">{addr.phone}</p>
              </div>
            </div>

            <div className="flex gap-2 pt-3 border-t border-gray-50" data-id="element-230">
              <button className="flex-1 flex items-center justify-center gap-1 text-sm font-medium text-gray-600 py-1.5 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-231">
                <Edit2 className="w-4 h-4" data-id="element-232" /> Edit
              </button>
              <div className="w-px bg-gray-100 my-1" data-id="element-233"></div>
              <button className="flex-1 flex items-center justify-center gap-1 text-sm font-medium text-error py-1.5 hover:bg-error/5 rounded-lg transition-colors" data-id="element-234">
                <Trash2 className="w-4 h-4" data-id="element-235" /> Delete
              </button>
            </div>
          </div>)}
      </div>

      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 p-4 pb-safe z-40" data-id="element-236">
        <div className="max-w-md mx-auto" data-id="element-237">
          <Button fullWidth icon={<Plus className="w-5 h-5" data-id="element-239" />} data-id="element-238">
            Add New Address
          </Button>
        </div>
      </div>
    </motion.div>;
}